import { FC } from "react";
import SpaceBetweenCenter from "shared/components/Layout/components/SpaceBetweenCenter";
import {
  ColoredSkeletonCard,
  SkeletonContainer,
  CoefficientSkeleton,
  TeamSkeleton,
  CenterSkeleton,
  SportSkeleton,
  BadgeSkeleton,
} from "./styled";

const ColoredSkeleton: FC = () => {
  const skeletons = Array.from({ length: 5 });

  return (
    <SkeletonContainer>
      {skeletons.map((_, index) => (
        <ColoredSkeletonCard key={index}>
          <SpaceBetweenCenter>
            <SportSkeleton />
            <BadgeSkeleton />
          </SpaceBetweenCenter>
          <SpaceBetweenCenter>
            <TeamSkeleton />
            <CenterSkeleton />
            <TeamSkeleton />
          </SpaceBetweenCenter>
          <SpaceBetweenCenter>
            <CoefficientSkeleton />
            <CoefficientSkeleton />
            <CoefficientSkeleton />
          </SpaceBetweenCenter>
        </ColoredSkeletonCard>
      ))}
    </SkeletonContainer>
  );
};

export default ColoredSkeleton;
